import React from 'react';
import type { BuiltResume } from '../../../resume-engine/types';
import { ResumeHeader } from '../components/ResumeHeader';
import { ResumeSummary } from '../components/ResumeSummary';
import { ExperienceSection } from '../components/ExperienceSection';
import { SkillsSection } from '../components/SkillsSection';
import { EducationSection } from '../components/EducationSection';

interface Props {
  resume: BuiltResume;
}

export function ExecutiveLayout({ resume }: Props) {
  return (
    <div className="resume-document resume-executive">
      <ResumeHeader contact={resume.contact} />
      <ResumeSummary summary={resume.summary} />
      <ExperienceSection experiences={resume.experiences} executive />
      <SkillsSection skills={resume.skills} compact />
      <EducationSection education={resume.education.slice(0, 1)} />
    </div>
  );
}
